import * as React from "react";
import type { SVGProps } from "react";

const SvgFilterClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="#142745"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.636.364a1.243 1.243 0 0 1 0 1.757L2.406 17.353a1.244 1.244 0 0 1-1.758-1.758L15.878.364a1.243 1.243 0 0 1 1.758 0m-5.76 9.756 5.476 5.475a1.244 1.244 0 0 1-1.757 1.758l-5.474-5.475zM.365.364a1.243 1.243 0 0 1 1.757 0l5.515 5.514-1.758 1.758L.364 2.122a1.244 1.244 0 0 1 0-1.758"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFilterClose;
